/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import PopUp from '../../../common/PopUp/PopUp'
import AddressBlock from '../../Quote/Step02/components/AddressBlock'
import { getSettlementBasis, settlementBasisCalc } from '../../../common/SettlementBasis'
import { get } from 'lodash'

/**
 *     Import
 *     - Styles
 */
import './styles/Summary.css'

export default class RenewalSummary extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            lapsePopUp: false,
            renewPolicyPopUp: false,
            renewPolicyReasonPopUp: false,
            renewalReason: '',

        }
    }

    // componentDidMount() {
    //     const policyId = this.props.match.params.id
    //     this.props.getFullQuoteRenewal(policyId)
    // }

    componentWillMount() {
        const policyId = this.props.match.params.id
        this.props.fecthRenewAsIs(policyId)
    }

    columnChunks = (arr, size) => {
        if (!Array.isArray(arr)) {
            throw new TypeError('Input should be Array')
        }

        if (typeof size !== 'number') {
            throw new TypeError('Size should be a Number')
        }

        let result: any = []
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, size + i))
        }

        return result
    }

    handleReasonChange = (r: any) => {
        this.setState({
            renewalReason: r,
        })
    }

    handleResponse = (btn = false) => {
        let res = this.props.renewPolicy.response

        if (res.success === true) {
            return btn ? 'Accept' : 'The policy has been renewed correctly'
        }

        return btn ? 'Close' : get(res, 'error', 'There was an error, please try again later')
    }

    getSectionTitle = () => {
        const { renewAsIs } = this.props

        if (get(renewAsIs, 'response.renewal.isCollectors', false)) {
            return 'Collections Insurance'
        } else if (get(renewAsIs, 'response.renewal.isMuseums', false)) {
            return 'Museums Insurance'
        } else if (get(renewAsIs, 'response.renewal.isDealersStock', false)) {
            return 'Dealers Stock Insurance'
        } else if (get(renewAsIs, 'response.renewal.isWineSpirits', false)) {
            return 'Wine & Spirits Insurance'
        } else if (get(renewAsIs, 'response.renewal.isCommercialProperty', false)) {
            return get(renewAsIs, 'response.renewal.policyName', 'Property Owners Insurance')
        } else {
            return 'Commercial Art Insurance'
        }
    }

    getSumInsuredTitle = () => {
        const { renewAsIs } = this.props

        if (get(renewAsIs, 'response.renewal.isCollectors', false)) {
            return 'Collection sum insured'
        } else if (get(renewAsIs, 'response.renewal.isMuseums', false)) {
            return 'Total Exhibits sum insured'
        } else if (get(renewAsIs, 'response.renewal.isDealersStock', false)) {
            return 'Total dealers stock sum insured'
        } else if (get(renewAsIs, 'response.renewal.isWineSpirits', false)) {
            return 'Total Collection sum insured'
        } else if (get(renewAsIs, 'response.renewal.isCommercialProperty', false)) {
            return 'Total delcared value'
        } else {
            return 'Total stock sum insured'
        }
    }

    render() {
        if (this.props.renewAsIs.done) {
            let { renewal } = this.props.renewAsIs.response
            let softRef = (
                (get(renewal, 'softOutcome', '') === '' ||
                    get(renewal, 'softOutcome') === false) && renewal.softReferrals) ? renewal.softReferrals : []
            let riskLocations = renewal.riskLocations
            const operativeSections = this.columnChunks(renewal.operativeSections, 5)
            return (
                <div className="renewals">
                    <HeaderContainer
                        className="renewals__header"
                        fullwidth={true}
                        back={true}
                        backAction={() => this.props.history.goBack()}
                        titles={['Bind Renewal']}
                    />
                    {(get(this.props, 'renewPolicy.loading', false)) ?
                        <PopUp
                            title="Renew a policy"
                            buttonText=""
                        >
                            ...Loading
                        </PopUp>
                        : null
                    }
                    {(this.props.lapseRenewal.done) ?
                        <PopUp
                            title="Lapse a renewal"
                            action={() => {
                                this.props.history.push(`/renewals`)
                                this.props.lapseRenewal.done = false
                            }}
                            buttonText="Accept"
                        >
                            {
                                this.props.lapseRenewal.response.success ?
                                    'The renewal has been lapsed correctly' :
                                    'There was an error, please try again later'
                            }
                        </PopUp>
                        : null
                    }
                    {(this.props.renewPolicy.done) ?
                        <PopUp
                            title="Renew a policy"
                            action={() => {
                                this.props.history.push(`/renewals`)
                                this.props.renewPolicy.done = false
                            }}
                            buttonText={this.handleResponse(true)}
                        >
                            {this.handleResponse()}
                        </PopUp>
                        : null
                    }
                    {(this.state.lapsePopUp) ?
                        <PopUp
                            title={'Are you sure?'}
                            action={() => {
                                this.props.fecthLapseRenewal(renewal.policyId)
                                this.setState({ lapsePopUp: false })
                            }}
                            buttonText={'Continue'}
                            numberButtons={2}
                            secondaryAction={() => { this.setState({ lapsePopUp: false }) }}
                            secondaryButtonText={'Cancel'}
                        >
                            Do you really want to lapse the renewal?
                        </PopUp>
                        : null
                    }
                    {
                        (this.state.renewPolicyPopUp && softRef.length > 0) ?
                            <PopUp
                                title="Renewal Policy Reason"
                                buttonText="Accept"
                                action={() => {
                                    this.setState({ renewPolicyPopUp: false })
                                    this.props.renewalReferralReasons(
                                        renewal.policyId,
                                        { reason: this.state.renewalReason }
                                    )
                                    this.props.fecthRenewPolicy(renewal.policyId)
                                }}
                                numberButtons={2}
                                secondaryAction={() => { this.setState({ renewPolicyPopUp: false }) }}
                                secondaryButtonText={'Cancel'}
                            >
                                <div className="quotePreview__box softRef">
                                    Due to the below you will need to provide more information.

                                    <div className="softRef__list">
                                        {/* {props.referrals.map((ref, i) => (
                                            <div key={i} className="softRef__item">
                                                <span>{ref.title}:</span>
                                                {ref.description}
                                            </div>
                                        ))} */}
                                    </div>

                                    <textarea
                                        placeholder="Explain in a few words your reasons"
                                        onChange={(event) => { this.handleReasonChange(event.target.value) }}
                                    />
                                </div>
                            </PopUp>
                            :
                            null
                    }

                    {
                        (this.state.renewPolicyPopUp && softRef.length === 0) ?
                            <PopUp
                                title={'Are you sure?'}
                                action={() => {
                                    this.setState({ renewPolicyPopUp: false })
                                    this.props.fecthRenewPolicy(renewal.policyId)
                                }}
                                buttonText={'Continue'}
                                numberButtons={2}
                                secondaryAction={() => { this.setState({ renewPolicyPopUp: false }) }}
                                secondaryButtonText={'Cancel'}
                            >
                                Do you really want to renew the policy?
                            </PopUp>
                            : null
                    }

                    <div className="renewals-widget__body">
                        <div className="summary">
                            <div className="summary__box">
                                <div className="summary__header">
                                    <div className="summary__header__title">
                                        {renewal.clientName}
                                    </div>
                                    <div className="summary__header__subtitle">
                                        {this.getSectionTitle()}

                                    </div>
                                    <div className="summary__header__policyInfo">
                                        Policy no. <span>{renewal.policyNumber}</span>
                                    </div>
                                </div>
                                <div className="summary__row">
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Inception date</div>
                                        <div className="summary__infoBlock__value">
                                            <span>{renewal.inceptionDate}</span>
                                        </div>
                                    </div>
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Expiry date</div>
                                        <div className="summary__infoBlock__value">
                                            <span>{renewal.expiryDate}</span>
                                        </div>
                                    </div>
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Premium</div>
                                        <div className="summary__infoBlock__value">
                                            <span>£{renewal.premium}</span> inc.IPT
                                        </div>
                                    </div>

                                </div>
                                <div className="summary__row">
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Your commission</div>
                                        <div className="summary__infoBlock__value">
                                            <span>{renewal.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">Excess</div>
                                        <div className="summary__infoBlock__value">
                                            <span>
                                                {(typeof (renewal.excess) === 'number') ?
                                                    (renewal.excess).toLocaleString('en-GB', {
                                                        style: 'currency',
                                                        currency: 'GBP',
                                                    })
                                                    :
                                                    `£${renewal.excess}`}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="summary__infoBlock">
                                        <div className="summary__infoBlock__title">
                                            {this.getSumInsuredTitle()}
                                        </div>
                                        <div className="summary__infoBlock__value">
                                            <span>£{renewal.totalSumInsured}</span>
                                        </div>
                                    </div>
                                    {(renewal.policyName === 'Collectors' || renewal.isCollectors ||
                                        renewal.isMuseums || renewal.isWineSpirits || renewal.isCommercialProperty)
                                        ? null : <div className="summary__infoBlock">
                                            <div className="summary__infoBlock__title">Settlement basis</div>
                                            <div className="summary__infoBlock__value">
                                                <span>
                                                    {
                                                        getSettlementBasis(
                                                            renewal.priceBasis,
                                                            renewal.settlementBasis
                                                        )
                                                    }
                                                    {settlementBasisCalc(renewal.settlementBasis)}%
                                                </span>
                                            </div>
                                        </div>}
                                </div>
                                <div className="summary__row">
                                    <div className="summary__infoBlock__value">
                                        <span>
                                            {(renewal.policyName === 'Collectors' ||
                                                renewal.isCollectors || renewal.isMuseums || renewal.isWineSpirits) &&
                                                renewal.riskLocations && (renewal.riskLocations).length > 0 ?
                                                'Risk addresses' : 'Operative sections'}
                                        </span>
                                    </div>
                                    {/* {operativeSections.map((row, i) => (
                                        <div key={i} className="summary__infoBlock">
                                            {
                                                row.map((col, y) => (
                                                    <div key={y} className="summary__infoBlock__value">{col}</div>
                                                ))
                                            }
                                        </div>
                                    ))
                                    } */}
                                    {(renewal.policyName === 'Collectors' || renewal.isCollectors ||
                                        renewal.isMuseums || renewal.isWineSpirits)
                                        && renewal.riskLocations && renewal.riskLocations.length > 0 ?
                                        <div className="PolicyAddressShow">
                                            {riskLocations.map((r, i) => {
                                                return (
                                                    <AddressBlock
                                                        key={i}
                                                        id={r.id}
                                                        quoteId={parseInt(this.props.match.params.id, 10)}
                                                        addressType={r.addressType}
                                                        addressLine1={r.addressLine1}
                                                        addressLine2={r.addressLine2}
                                                        city={r.city}
                                                        postcode={r.postcode}
                                                        addressAllocated={r.allocated}
                                                    />
                                                )
                                            })}
                                        </div>
                                        :
                                        operativeSections.map((row, i) => (
                                            <div key={i} className="summary__infoBlock">
                                                {
                                                    row.map((col, y) => (
                                                        <div key={y} className="summary__infoBlock__value">{col}</div>
                                                    ))
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className="summary__row no-padding">
                                    <Button
                                        half={true}
                                        type="button"
                                        onClick={() => this.setState({ lapsePopUp: true })}
                                    >
                                        LAPSE
                                    </Button>
                                    <Button
                                        half={true}
                                        type="submit"
                                        onClick={() => {
                                            this.setState({ renewPolicyPopUp: true })
                                        }}
                                    >
                                        RENEW POLICY
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            )
        } else {
            return (<div />)
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/Summary/Summary.tsx